import { FilterCategoryCard } from "@/components/campaign/FilterCategoryCard";
import { filterCategories } from "@/data/filters/config";
import { ToOptions } from "@tanstack/react-router";

export function FilterCategories({
  buildLink,
}: {
  buildLink: (category: string) => ToOptions;
}) {
  return (
    <ul className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 xl:gap-6">
      {Object.entries(filterCategories).map(([category, config]) => (
        <FilterCategoryCard
          key={category}
          category={config}
          link={buildLink(category)}
        />
      ))}
    </ul>
  );
}
